// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleOutlinedSvg from "@fishx/icons-svg/es/asn/GoogleOutlined";
import FishxIcon from '../components/FishxIcon';

var GoogleOutlined = function GoogleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleOutlinedSvg
  }));
};

GoogleOutlined.displayName = 'GoogleOutlined';
export default React.forwardRef(GoogleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoogleOutlined.js
// module id = 2896
// module chunks = 0